import { render, staticRenderFns } from "./startBtn.vue?vue&type=template&id=6d522bb3&scoped=true"
import script from "./startBtn.vue?vue&type=script&lang=js"
export * from "./startBtn.vue?vue&type=script&lang=js"
import style0 from "./startBtn.vue?vue&type=style&index=0&id=6d522bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d522bb3",
  null
  
)

export default component.exports